<template>
    <div>
        <div>
            <router-link :to="{name:'WorkPage',params:{workTitle:work.title}}"> {{work.title}}
            </router-link>

        </div>
    </div>
</template>

<script>
    export default {
        name: "WorkBox",
        props: ['work']
    }
</script>

<style scoped lang="scss">
    a {
        color: maroon;

        &.router-link-exact-active {
            color: red;
        }

    }
</style>